import * as yup from "yup";

export const configFolioSchema = yup.object().shape({
  folioContado: yup
    .string()
    .min(1, "Debe tener al menos 1 carácter")
    .max(15, "No debe exceder 15 caracteres")
    .required("Ingrese el folio contado"),

  folioCredito: yup
    .string()
    .min(1, "Debe tener al menos 1 carácter")
    .max(15, "No debe exceder 15 caracteres")
    .required("Ingrese el folio crédito"),
});
